import React from 'react';
import { 
  HelpCircle,
  Mail, 
  Code, 
  Globe, 
  Smartphone, 
  Shield, 
  Zap, 
  Users 
} from 'lucide-react';

/**
 * Компонент с полезными советами по использованию
 */
const UsageTips = () => {
  const tips = [
    {
      icon: Mail,
      title: 'Тема письма',
      description: 'Используйте короткие и информативные темы — это повышает шанс прочтения письма.'
    },
    {
      icon: Code,
      title: 'Кириллица',
      description: 'Для корректного отображения русских букв включите специальную опцию кодирования.'
    },
    {
      icon: Smartphone,
      title: 'Мобильные устройства',
      description: 'Тестируйте mailto-ссылки на мобильных устройствах — они могут работать иначе, чем на ПК.'
    },
    {
      icon: Shield,
      title: 'Защита от спама',
      description: 'Для защиты от спам-ботов можно использовать JavaScript для генерации mailto-ссылок на лету.'
    },
    {
      icon: Zap,
      title: 'Отслеживание',
      description: 'Добавляйте UTM-метки для отслеживания эффективности email-маркетинга в аналитике.'
    },
    {
      icon: Users,
      title: 'Получатели',
      description: 'Вы можете указать несколько адресов получателей, разделяя их запятыми.'
    },
    {
      icon: Globe,
      title: 'Длина ссылки',
      description: 'Избегайте слишком длинных mailto-ссылок — некоторые браузеры имеют ограничения.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-0.5">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нужна помощь с email-маркетингом?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Узнайте, как повысить эффективность ваших email-кампаний с помощью правильно настроенных mailto-ссылок и отслеживания.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Получить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageTips;